export default __webpack_public_path__ + "static/media/courtdateinner.ad51d07b.svg";